(ns frontend.view.reports.util
  (:require
   [common.localization :as loc]
   [frontend.state.current-session :as session]
   [frontend.tenant-customizations :as tenant-customizations]))

(defn report-title
  [routing-kw]
  (case routing-kw
    :custom-reports
    (cond
      (tenant-customizations/alj?)
      "ALJ Global - Reports OLD"

      (and (tenant-customizations/capman?)
           (tenant-customizations/capman-buyout-pipeline-access?))
      "Buyout reports"

      (tenant-customizations/diamond-edge-ventures?)
      "Reports : Tables"

      :else
      (loc/tr :reports/custom-reports [@session/tenant-name]))
    :custom-reports-2
    (cond (tenant-customizations/alj?)
          "ALJ Global - Reports 2"

          (and (tenant-customizations/capman?)
               (tenant-customizations/capman-buyout-pipeline-access?))
          "Buyout reports"

          (tenant-customizations/diamond-edge-ventures?)
          "Reports : Graphs"

          :else
          (loc/tr :reports/custom-reports-2 [@session/tenant-name]))
    :custom-reports-3
    (cond (tenant-customizations/diamond-edge-ventures?)
          "Reports : deals throughput"

          (tenant-customizations/capman?)
          "Contacts report"

          :else
          (loc/tr :reports/custom-reports-3 [@session/tenant-name]))))
